<template>
    <!-- <v-container> -->
        <!----->
        <div width="2000px">
          <!-- <li v-for="ttdItem in ttdItems">
            <p v-if="ttdItem.koordinat">
            pdfX {{ ttdItem.koordinat.pdfX }} pdfY {{ ttdItem.koordinat.pdfY }} pdfWidth {{ ttdItem.koordinat.pdfWidth }} pdfHeight {{ ttdItem.koordinat.pdfHeight }} width {{ ttdItem.koordinat.width }} height {{ ttdItem.koordinat.height }} 
            </p>
          </li> -->
              <img v-for="(item, index) in ttdItems"
                  :src="item.path"
                  :key="item.id" class="draggable resizable"
                  v-if="((!item.page || item.page == 0 || item.page > numPages) || (item.page == page)) && source" 
                  :style="'z-index: +2; position: absolute;' + (item.koordinat ? ('left:' +item.koordinat.x +'px; top:' +item.koordinat.y + 'px')  : '')" 
                  :width="(!item.koordinat) ? '200' : item.koordinat.width"
                  :alt="'Gambar ' + item.id + ' gagal di-load'"
                  :id="item.id" @mouseover="mouseOverTtdItem(item.id)" @mouseleave="mouseOutTtdItem(item.id)"/>
            <div style="margin-left: 500px;">
              <br/>
              <v-row>
                <v-col sm="6">
                  <p v-if="ttdItems.filter(item => (!item.page || item.page == 0 || item.page > numPages)).length > 0 && source">{{ ttdItems.filter(item => (!item.page || item.page == 0 || item.page > numPages)).length }} Item Perlu Diposisikan Pada Dokumen</p>
                  <p v-if="ttdItems.filter(item => (!item.page || item.page == 0 || item.page > numPages)).length <= 0 && source">Semua Item Sudah Diposisikan Pada Dokumen</p>
                  <br/>
                  <v-btn v-if="source" @click="generatePDF('base64')">Generate PDF</v-btn> 
                  <br/>
                  <div style="display: flex; justify-content: space-between;">
                    <v-text-field v-if="source" v-model.number="page" type="number" :min="1" :max="numPages"> </v-text-field> 
                    <p v-if="source" style="width: 50%">/ {{ numPages }}</p>
                  </div>
                </v-col>
                <v-col sm="6">
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Koordinat Tanda Tangan
                      </v-expansion-panel-header>
                      <v-expansion-panel-content style="height: 75px;overflow: overlay;">
                        <ul>
                          <li v-for="ttdItem in ttdItems">
                            <div v-if="ttdItem.page > 0 && ttdItem.page <= numPages">
                               koordinat {{ ttdItem.id }}: <br/>
                              <v-row>
                                <v-col sm="3" style="padding-top:13px;">
                                  adjust x:
                                </v-col>
                                <v-col sm="3">
                                  <v-text-field :disabled="ttdItem.koordinat.page !== page" style="padding-top:0px!important;" :value="ttdItem.koordinat.pdfX" :id="ttdItem.id + '_x'" type="number" @change="transformX(ttdItem.id + '_x', ttdItem.id)"></v-text-field>
                                </v-col>
                              
                                <v-col sm="3" style="padding-top:13px;">
                                  adjust y:

                                </v-col>
                                <v-col sm="3">
                                  <v-text-field :disabled="ttdItem.koordinat.page !== page" style="padding-top:0px!important;" :value="ttdItem.koordinat.pdfY" :id="ttdItem.id + '_y'" type="number" @change="transformY(ttdItem.id + '_y', ttdItem.id)"></v-text-field>
                                </v-col>
                              </v-row>
                               {{ '{' + 'x: "' + ttdItem.koordinat.pdfX + '",'}}
                               {{ 'y: "' + ttdItem.koordinat.pdfY + '",'}}
                               {{ 'pdfX: "' + ttdItem.koordinat.pdfX * 100 / 100 + '",'}}
                               {{ 'pdfY: "' + ttdItem.koordinat.pdfY * 100 / 100 + '",'}}
                               {{ 'width: "' + ttdItem.koordinat.width * 100 / 100 + '",'}}
                               {{ 'height: "' + ttdItem.koordinat.height * 100 / 100 + '",'}}
                               {{ 'page: "' + ttdItem.koordinat.page + '", }'}}
                            </div>
                          </li>
                        </ul>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
              <br/>
              <p v-if="!source">File Belum Ada</p>
              <p v-if="source && !numPages">File Gagal Dimuat</p>
              
              <div ref="pdf" style="margin: 0px;">
              <pdf v-if="source" :src="source" :page="page"  @num-pages="numPages = $event" class="pdf-page" id="dropzone-pdf"
                style="z-index: 1; margin: 0px; border:1px solid black; width:1200px;">
              </pdf>
              </div>
            </div>
        </div>
    <!-- </v-container> -->
</template>
<script>
import pdf from 'vue-pdf'
import interact from 'interactjs'
import Vue, { getCurrentInstance } from "vue";
import { apiServer, docConverter } from "../../setup-axios";
import { backendUrl } from '../../config/env' 


export default {
    components: {
      pdf
    },
    props: {
        source: null,
        ttdItems: [],
        dialog: true,
        permission: '',
    },
    watch: { 
      dialog: function(newVal, oldVal) { // watch it

          if((oldVal === false || !oldVal) && newVal === true) {            
            this.positionTtdImagesForDragAndDrop()
            this.page = 1
            this.$forceUpdate()
          }
      },
      page: function(newVal, oldVal) { // watch it
        this.initDraggable()
      },
    },
    data: () => ({
        page: 1,
        numPages: 0,
        zoom: 50,
        canvas: null,
        loadedRatio: 0,
        originalWidth: 0,
        originalHeight: 0,
        backendUrl: backendUrl,
        resizeOption: {
            edges: { left: true, right: true, bottom: true, top: true }
        },
        dragOption: {
            modifiers: [
            interact.modifiers.restrictRect({
                restriction: "parent",
                endOnly: true
            })
            ],
        },
        // values for interact.js transformation
        x: 0,
        y: 0,
        w: 200,
        h: 200,
        updateOnce: false,
        request: {},
        namaFile: ""
    }),
    computed: {
      style() {
        return {
        //   height: `${this.h}px`,
        //   width: `${this.w}px`,
          transform: `translate(${this.x}px, ${this.y}px)`,
        };
      }
    },
    mounted() {
      this.positionTtdImagesForDragAndDrop()
      this.page = 1
    },
    methods: {
      async generatePDF(tipe) {
        var base64 = ""
        var thisVm = this
        await fetch(this.source)
        .then(response => response.blob())
        .then(async blob => {
          // Convert the Blob to base64
          var reader = new FileReader();
          await reader.readAsDataURL(blob);
          reader.onload = async function() {
            base64 = reader.result.split(',')[1];
            thisVm.request.pdfSource = base64
            thisVm.request.ttdItems = thisVm.ttdItems
            await thisVm.apiGeneratePdf(thisVm.request, tipe)
            
          };
        })
        .catch(error => {
          console.error(error);
          alert(JSON.stringify(error))
          return "error"
        });
        return this.namaFile
        

      },
      async apiGeneratePdf(request, tipe) {
        var array = []
        for(var ii = 0; ii < request.ttdItems.length; ii++) {
          if(request.ttdItems[ii].page <= this.numPages) {
            request.ttdItems[ii].koordinat.id = request.ttdItems[ii].id
            array.push(request.ttdItems[ii].koordinat)
          }
        }
        console.log('url generate pdf', docConverter.defaults.baseURL)
        const timestamp = new Date().getTime()

        await docConverter
          .post('/generate-document-' + tipe + '?timestamp=' + timestamp, {
              pdfBase64: request.pdfSource,
              imgParameter: JSON.stringify(array),
              username: JSON.parse(localStorage.getItem("user")).username
          }, {responseType: "blob"})
          .then(response => {
            console.log(response.data)
            if(tipe === 'base64') {
              var fileURL = window.URL.createObjectURL(response.data);
              let tab = window.open();
              tab.location.href = fileURL;
            } else {
              alert(response.data)
              this.namaFile = response.data
            }
            //alert(JSON.stringify(response))
          })
          .catch(error => {
            console.log(error)
            throw error
          });
      },
      getParent(name) {
        let p = this.$parent;
        while(typeof p !== 'undefined') {
            if (p.$options.name == name) {
                return p;
            } else {
                p = p.$parent;
            }
        }
        return false;
      },
      loadWidth() {
        var pdfPages = document.getElementsByClassName('pdf-page')
        
        if(pdfPages.length > 0) {
          this.originalWidth =  pdfPages[0].offsetWidth
          this.originalHeight = pdfPages[0].offsetHeight
        }

      },
      findElementById(id, array) {
        for(var ii = 0; ii < array.length; ii++) {
          if(id + '' == array[ii].id + '') {
            return array[ii]
          }
        }
      },
      positionTtdImagesForDragAndDrop() {
        var thisVm = this
        var interval = setInterval(function () {
          console.log('checkttd')
          var allTtdLoaded = thisVm.checkTtdLoaded()
          if(allTtdLoaded) {
            thisVm.setPosition()
            thisVm.initDraggable()
            thisVm.initDropzone()
            clearInterval(interval)
          }
        }, 200);
      },
      async setPosition() {
        var previousElementHeight = -1
        var firstPositionSet = false
        for(var ii = 0; ii < this.ttdItems.length; ii++) {

          // set element position if it doesn't have saved coordinates, based on previous elements' position
          var img =  document.getElementById(this.ttdItems[ii].id + '')

          if(img && (!this.ttdItems[ii].koordinat || !this.ttdItems[ii].page || this.ttdItems[ii].page == 0 || this.ttdItems[ii].page > this.numPages)) {
            var originalProportion = 1.0 * img.clientWidth / img.clientHeight
            var width = 200
            if(this.ttdItems[ii].id === 'DeskripsiQR') {
              width = 500
            }
            img.style.width = width + 'px'

            var height = (width / originalProportion)
            img.style.height = height + 'px'

            var yCoordinate;
            var xCoordinate = 100;
            if(!firstPositionSet) {
              yCoordinate = 150
              previousElementHeight = img.clientHeight + yCoordinate
              firstPositionSet = true
            } else {
              yCoordinate = previousElementHeight
              previousElementHeight = previousElementHeight + img.clientHeight
            }
            img.style.left = xCoordinate + 'px'
            img.style.top = yCoordinate + 'px'
            // debug item
            //alert(width)
            var koordinat = {x: xCoordinate, y: yCoordinate, width: width, height: height}
            this.ttdItems[ii].koordinat = koordinat
            this.ttdItems[ii].page = 0
          } else if(img) {
            img.style.left = this.ttdItems[ii].koordinat.x + 'px'
            img.style.top = this.ttdItems[ii].koordinat.y + 'px'
            // debug item
            //alert(this.ttdItems[ii].koordinat.width + ' x')
          }
          this.ttdItems[ii].koordinat.base64Src = this.ttdItems[ii].path
        }
      },
      mouseOverTtdItem(id) {
        var element = document.getElementById(id + '');
        element.classList.add('image-border');
        this.initDraggable()
      },
      mouseOutTtdItem(id) {
        var element = document.getElementById(id + '');
        element.classList.remove('image-border');
      },
      initDraggable() {
        //alert('')
        for(var ii = 0; ii < this.ttdItems.length; ii++) {
          var item = this.ttdItems[ii]
          console.log(item.id + ' ' + item.page + ' ' + (item.koordinat ? (item.koordinat.width + "width, " + item.koordinat.height + "height, "
                  + item.koordinat.pdfX + "pdfX, " + item.koordinat.pdfY + "pdfY, "
                  + item.koordinat.x + "x, " + item.koordinat.y + "y") : '' ))
        }
        if(this.permission !== 'Detail') {
          var ttdItemsArr = this.ttdItems
          var thisVm = this
          var findElementById = this.findElementById
          var draggables = document.getElementsByClassName('draggable')
          for (var ii = 0; ii < draggables.length; ii ++) {
            var element = draggables[ii]
            interact('#' + element.id).draggable({
              inertia: true,
              modifiers: [
              interact.modifiers.restrictRect({
                restriction: 'parent',
                endOnly: true
              })
            ],
              autoScroll: true,
              listeners: {
                move (event) {
                  var elementPos = findElementById(event.target.id, ttdItemsArr)
                  //alert(JSON.stringify(elementPos.koordinat))
                  if(elementPos && elementPos.koordinat) {
                  elementPos.koordinat.x = (elementPos.koordinat.x || 0) + event.dx
                  elementPos.koordinat.y = (elementPos.koordinat.y || 0) + event.dy
                  event.target.style.left = elementPos.koordinat.x + 'px'
                  event.target.style.top = elementPos.koordinat.y + 'px'
                  }

                  thisVm.$forceUpdate()
                },
              }
            })
            .resizable({
              edges: { top: true, left: true, bottom: true, right: true },
              invert: 'reposition',
              listeners: {
                move: function (event) {
                  const { width, height } = event.rect
                  const offset = { x: 0, y: 0 }

                  offset.x += event.deltaRect.left
                  offset.y += event.deltaRect.top

                  var elementWidth = findElementById(event.target.id, ttdItemsArr)
                  elementWidth.koordinat.width = width
                  elementWidth.koordinat.height = height
                
                  Object.assign(event.target.style, {
                    width: `${width}px`,
                    height: `${height}px`,
                    transform: `translate(${offset.x}px, ${offset.y}px)`
                  })
                  thisVm.$forceUpdate()
                }
              },
              modifiers: [
                interact.modifiers.aspectRatio({
                  // make sure the width is always double the height
                  ratio: element.width / element.height,
                  // also restrict the size by nesting another modifier
                  modifiers: [
                    interact.modifiers.restrictSize({ max: 'parent' }),
                  ],
                }),
              ],
            })
          }
        } 
      },
      async checkTtdLoaded() {
        var isLoaded = true
        var imageArr = document.getElementsByClassName('draggable')
        if(imageArr && imageArr.length > 0) {
          for(var ii = 0; ii < this.ttdItems.length; ii++) {
            var value = imageArr[ii]
            //alert('ss'+JSON.stringify(value))
            var itemLoaded = false
            if(value) {
              if(!itemLoaded) {
                itemLoaded = value.complete
              }
            }
            isLoaded = isLoaded && itemLoaded
          }
        }
        return isLoaded
      },
      transformX(idForm, id) {
        var img =  document.getElementById(id + '')
        var form =  document.getElementById(idForm + '')
        var pdf = document.getElementById('dropzone-pdf')

        var element = this.findElementById(id, this.ttdItems)


        var dropzonePostion = pdf.getBoundingClientRect()

        var pdfX = parseInt(form.value)
        var x = pdfX + dropzonePostion.left
        img.style.left = x 
        element.koordinat.x = x
        element.koordinat.pdfX = pdfX 
        this.$forceUpdate();

      },
      transformY(idForm, id) {
        var img =  document.getElementById(id + '')
        var form =  document.getElementById(idForm + '')
        var pdf = document.getElementById('dropzone-pdf')

        var element = this.findElementById(id, this.ttdItems)


        var dropzonePostion = pdf.getBoundingClientRect()

        var pdfY = parseInt(form.value)
        var y = pdfY + dropzonePostion.top

        img.style.top = y 
        element.koordinat.y = y
        element.koordinat.pdfY = pdfY 
        this.$forceUpdate();

      },
      initDropzone() {
        var thisVm = this
        interact('.pdf-page').dropzone({
            // only accept elements matching this CSS selector
            accept: '.draggable',
            // Require a 100% element overlap for a drop to be possible
            overlap: 1,
            // listen for drop related events:
            ondragenter: function (event) {
              var element = thisVm.findElementById(event.relatedTarget.id, thisVm.ttdItems)

              if(element) {
                //console.log(JSON.stringify(element))
                element.page = thisVm.page
              }
              //alert('enter ' + element.page)

            },
            ondragleave: function (event) {
              var element = thisVm.findElementById(event.relatedTarget.id, thisVm.ttdItems)
              if(element) {
                //console.log(JSON.stringify(element))
                element.koordinat.page = 0
                element.page = 0
                
              }

            },
            ondrop: function (event) {
              var element = thisVm.findElementById(event.relatedTarget.id, thisVm.ttdItems)
              //alert(element)
              console.log('find', event.relatedTarget.id)
              console.log(thisVm.ttdItems)
              if(element && element.koordinat) {
                //console.log(JSON.stringify(element))
                element.page = thisVm.page

                var dropzonePostion = event.target.getBoundingClientRect()
                var elementPosition = event.relatedTarget.getBoundingClientRect()
                element.koordinat.page = thisVm.page
                element.koordinat.pdfWidth = dropzonePostion.width
                element.koordinat.pdfHeight = dropzonePostion.height
                element.koordinat.pdfX = parseInt(elementPosition.left - dropzonePostion.left),
                element.koordinat.pdfY = parseInt(elementPosition.top - dropzonePostion.top)
              }
              
            }
        });

      }
    }
}
</script>
<style scoped>
.resize-drag {

  /* To prevent interact.js warnings */
  user-select: none;
  -ms-touch-action: none;
  touch-action: none;
}
</style>